// project import

import { getPages } from './pages';

// ==============================|| MENU ITEMS ||============================== //

const getMenuItems = (permissions) => {
  return {
    items: [getPages(permissions)]
  };
};

export default getMenuItems;
